import {addSeconds} from "date-fns";

//Function to add duration to date
export function parseDurationToSeconds(startDate: Date, durationString: string): Date {
    const totalSeconds = parseDuration(durationString);
    return addSeconds(startDate, totalSeconds);
}

// Функция для парсинга duration(например: PT1H) в секунды
function parseDuration(durationString: string): number {
    if (durationString === null) {
        return 0;
    }
    const regex = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;
    const matches = durationString.match(regex);

    if (!matches) {
        throw new Error('Invalid duration format');
    }

    const hours = parseInt(matches[1] || '0', 10);
    const minutes = parseInt(matches[2] || '0', 10);
    const seconds = parseInt(matches[3] || '0', 10);

    return hours * 3600 + minutes * 60 + seconds;
}
